import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useEffect, useState, useContext } from 'react';
import { MessagesContext } from "../common/context";

// import { graph } from '@pnp/graph';
// import { WebPartContext } from "@microsoft/sp-webpart-base";
import { useErrorBoundary } from "use-error-boundary";
import log from 'loglevel';

import * as Fabric from 'office-ui-fabric-react';
import { TextField } from "office-ui-fabric-react";
import { CommandBar} from 'office-ui-fabric-react/lib/CommandBar';

import { escape } from '@microsoft/sp-lodash-subset';
import { PIVOT_KEY } from '../common/consts';


import  * as uuidv4 from "uuid/v4";
import {  classNames, chatMessageBarStyle, chatMessageBodyStyle} from "./ChatMessage.Styles";

/**
 * 
 * GET /me/chats/{id}/messages/{id}
* GET /users/{id}/chats/{id}/messages/{id}
* GET /chats/{id}/messages/{id}
*/

/**
 * 
 * @param {
 * 
 * } param0 
 */
export  function ChatMessage({ chatId, chatMessageId, chatMessage, accessToken }) {

    const {dispatch} = useContext(MessagesContext);
    const [isCheckedM, setIsCheckedM] = useState(false);

    const [showChatMessageContent, setShowChatMessageContent] = useState(false);

    const { ErrorBoundary, didCatch, error, errorInfo } = useErrorBoundary();
    log.info(` @ ChatMessage`);

    useEffect(() => {
        log.info(`useEffect @ ChatMessage`);
        if ( isCheckedM ) 
        {         
          addItem(chatMessage) 
        }
    }, [isCheckedM]);


    const handleToItemsM = ()=>{
      log.info(`handleToItemsM @ ChatMessage`); 
      setIsCheckedM(!isCheckedM); 
    }

  

    const addItem = (item) =>{
      log.info(`addItem @ ChatMessage`); 
      const _item = {
        id: uuidv4(),
        date: item.date,
        text : item.text,
        webUrl : ``,//item.webUrl,
        user : item.user,
        type : item.type,
        selected: true 
      };
      dispatch({ type: "ADD_MESSAGE", payload: _item });

      const ___payload = { pivotKey:  PIVOT_KEY.ITEMS};
      dispatch({ type: "SET_PIVOT_KEY", payload: ___payload })
    }

    const handleMessageWebUrl = ()=>{
      log.info(`handleMessageWebUrl @ ChatMessage`); 
       //window.open(message.webUrl, '_blank')
    }


    const _items = [
      {
        key: 'perona',
        text: chatMessage.user,
        iconOnly: true,
        iconProps: { iconName: 'Contact' },
      },
      // { // not suported yet
      //   key: 'open',
      //   text: 'Open in Chat',
      //   iconOnly: true,
      //   iconProps: { iconName: 'OpenInNewTab' },
      //   onClick: () => {
      //     handleMessageWebUrl();
      //   }
      // },
      {
        key: 'title',
        iconProps: { iconName: 'MessageFill' },
        text: `${chatMessage.text.replace( /(<([^>]+)>)/ig, '').substr(0,50)}`,
        onClick: () => {setShowChatMessageContent(!showChatMessageContent)}
      }
    ];

    const _farItems = [
      {
        key: 'toItemsM',
        text: 'Copy ChatMessage to Items',
        iconOnly: true,
        iconProps: { iconName: 'Copy' },
        onClick:  ()=>{ handleToItemsM(); } 
      } 
    ];
    
    const renderChatMessageBar=()=>{
      log.info(`renderChatMessageBar @ ChatMessage`);       
      return (
        <ErrorBoundary  
          render={()=>
          <div style={chatMessageBarStyle()} >
            <CommandBar
                    items={_items}
                    farItems={_farItems}
                  />
            </div>
          }
          renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}  
        />
      );  
    };

    const renderChatMessage=()=>{
      return (

        showChatMessageContent ? 
              (
                <ErrorBoundary 
                      render={()=>

                                <div style={chatMessageBodyStyle()} >
                                  {chatMessage.text.replace( /(<([^>]+)>)/ig, '')}
                                </div> 
                              }
                      renderError={({ error, errorInfo }) => <MyErrorComponent error={error} />}        
                ></ErrorBoundary>              
              ) : ''
              );  
    };
  
    const MyErrorComponent = ({error})=>{  
      log.error(`MyErrorComponent @ ChatMessage error ${error.message}`);
    return (
        <div >Error. Search in Logs for details.</div>
    )
  }

    return (
      <> 
        { renderChatMessageBar() }
        { renderChatMessage() }
      </>
    );
}


